import { ErrorHandler, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse, provideHttpClient, withJsonpSupport } from '@angular/common/http';

import { CustomersRoutingModule } from './customers-routing.module';
import { SignupComponent } from './signup/signup.component';
import { CustomerHeaderComponent } from './customer-header/customer-header.component';

import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { CustomerFeedbackCardComponent } from './customer-feedback-card/customer-feedback-card.component';
import { BannerComponentComponent } from './banner-component/banner-component.component';
import { RepairTabsComponent } from './repair-tabs/repair-tabs.component';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { GuestRepairComponent } from './guest-repair/guest-repair.component';
import { CustomerSellPhoneComponent } from './customer-sell-phone/customer-sell-phone.component';
import { CustomerShoppingComponent } from './customer-shopping/customer-shopping.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CustomerBottomBannerComponent } from './customer-bottom-banner/customer-bottom-banner.component';
import { LuckyDrawComponent } from './lucky-draw/lucky-draw.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ForumComponent } from './forum/forum.component';
import { ForumProfilePopupComponent } from './forum/profile-popup/profile-popup.component';
import { PollComponent } from './forum/poll/poll.component';
import { GiveawayComponent } from './forum/giveaway/giveaway.component';
import { GiveawaySurveyComponent } from './forum/giveaway/giveaway-survey/giveaway-survey.component';
import { NotificationComponent } from './marketplace/notification/notification.component';
import { NotificationBookingComponent } from './marketplace/notification/notification-booking/notification-booking.component';
import { ShareModule } from 'src/app/shareModule/shareModule';
import { MarketplaceProfileCharacterComponent } from './layout/component-layout/profile-character/marketplace-profile-character.component';
// import { MemberShopProductComponent } from './marketplace/member-shop-product/member-shop-product.component';
import { MemberShopProductSearchComponent } from './marketplace/member-shop-product/shop-search/shop-search.component';
import { GoogleMapComponent } from './marketplace/google-map/google-map.component';
import { ClickOutsideDirective } from '../shareModule/directive/ngbd-click-outside/ngbd-click-outside.directive';
import { CommonFooterComponent } from './common/common-footer/common-footer/common-footer.component';
import { SingleNewComponent } from './news/single-new/single-new.component';
import { FormNewComponent } from './news/form-new/form-new.component';
import { MarketplacePageComponent } from './marketplace/marketplace.component';
import { MarketplaceShopDetailComponent } from './marketplace/shop-detail/marketplace-shop-detail.component';
import { NewsComponent } from './news/news.component';
import { BulletinComponent } from './news/bulletin/bulletin.component';
import { CustomersLayoutComponent } from './layout/customers-layout/customers-layout.component';
import { CustomersLayoutReferralComponent } from './layout/customers-layout-referral/customers-layout-referral.component';
import { ChatComponent } from 'src/app/shareModule/component/chat/chat.component';
import { ChatBotComponent } from 'src/app/shareModule/component/chat/chatbot/chatbot.component';
import { ChatLearnComponent } from 'src/app/shareModule/component/chat/chatlearn/chat-learn.component';
import { ChatMemoryComponent } from 'src/app/shareModule/component/chat/chatmemory/chat-memory.component';
import { RolesComponent } from './community/roles/roles.component';
// import { EditorComponent } from './editor/editor.component';
import { TabForumComponent } from './forum/tab-forum/tab-forum.component';
import { MemberPageComponent } from './community/member-page/member-page.component';
import { CommunitySearchComponent } from './community/community-search/community-search.component';
import { CommunityProfileComponent } from './community/profile/profile.component';
import { HeaderSearchMapComponent } from './community/filter-products/header-search-map/header-search-map.component';
import { FilterProductsComponent } from './community/filter-products/filter-products.component';
import { SearchComponent } from './community/search/search.component';
import { ProfileMeComponent } from './community/member-page/me/profile-me/profile-me.component';
import { AskMeComponent } from './community/member-page/me/ask-me/ask-me.component';
import { NewsMeComponent } from './community/member-page/me/news-me/news-me.component';
import { AddMeComponent } from './community/member-page/me/add-me/add-me.component';
import { NearbyproductsMeComponent } from './community/member-page/me/nearbyproducts-me/nearbyproducts-me.component';
import { MemberProfileCharacterComponent } from './marketplace/member-profile-character/member-profile-character.component';
import { EventsComponent } from './community/events/events.component';
import { OnlineToggleButtonComponent } from './online-toggle-button/online-toggle-button.component';
import { IndividualRentalComponent } from './community/member-page/me/nearbyproducts-me/individual-rental/individual-rental.component';
import { IndividualAllProductComponent } from './community/member-page/me/nearbyproducts-me/individual-all-product/individual-all-product.component';
import { IndividualFreeComponent } from './community/member-page/me/nearbyproducts-me/individual-free/individual-free.component';
import { IndividualServicesComponent } from './community/member-page/me/nearbyproducts-me/individual-services/individual-services.component';
import { IndividualEventsComponent } from './community/member-page/me/nearbyproducts-me/individual-events/individual-events.component';
import { OtherCommuntyPageComponent } from './community/other-communty-page/other-communty-page.component';
import { BuyComponent } from './community/other-communty-page/buy/buy.component';
import { SellComponent } from './community/other-communty-page/sell/sell.component';
import { ReferComponent } from './community/other-communty-page/refer/refer.component';
import { WriteArticlesComponent } from './community/other-communty-page/write-articles/write-articles.component';
import { MarketplaceProfileComponent } from './layout/component-layout/marketplace-profile/marketplace-profile.component';
import { LevelProfileComponent } from './layout/component-layout/profile-character/level-profile/level-profile.component';
import { AvatarProfileComponent } from './layout/component-layout/profile-character/avatar-profile/avatar-profile.component';
import { StoreProfileComponent } from './layout/component-layout/profile-character/store-profile/store-profile.component';
import { MyTabsComponent } from './layout/component-layout/my-tabs/my-tabs.component';
import { MemberShopComponent } from './layout/component-layout/member-shop/member-shop.component';
import { LoudspeakerShopComponent } from './layout/component-layout/loudspeaker-shop/loudspeaker-shop.component';
import { TimerComponent } from './community/events/timer/timer.component';
import { ShopPageComponent } from './shop-page/shop-page.component';
import { HowToEarnComponent } from './community/other-communty-page/how-to-earn/how-to-earn.component';
import { SignInComponent } from './layout/component-layout/sign-in/sign-in.component';
import { TermsOfServiceComponent } from './community/other-communty-page/terms-of-service/terms-of-service.component';
import { TermsOfRentalComponent } from './community/other-communty-page/terms-of-rental/terms-of-rental.component';
import { MemberRegionSelectModalComponent } from './common/common-member-region-select-modal/member-region-select-modal.component';
import { MemberProfileRolesComponent } from './layout/component-layout/profile-character/member-profile-roles/member-profile-roles.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { CarouselMiniCardComponent } from './news/carousel-mini-card/carousel-mini-card.component';
import { SettingProfileComponent } from './layout/component-layout/setting-profile/setting-profile.component';
import { DiamondsPopupComponent } from './layout/component-layout/profile-character/level-profile/diamonds-popup/diamonds-popup.component';
import { OtpInputComponent } from './layout/component-layout/sign-in/otp-input/otp-input.component';
import { PDPAPolicyComponent } from './layout/component-layout/sign-in/pdpa-policy/pdpa-policy.component';
import { ViewProductDetailsComponent } from './marketplace/view-product-details/view-product-details.component';
// import { CustomerServiceComponent } from '../shareModule/component/chat/customer-service/customer-service.component';
import { SurveyComponent } from './layout/component-layout/survey/survey.component';
import { AroundeMeComponent } from './community/member-page/me/around-me/around-me.component';
import { DropdownStatusComponent } from './layout/component-layout/dropdown-status/dropdown-status.component';
import { JobCompleteCofirmationModalComponent } from './job-complete-cofirmation-modal/job-complete-cofirmation-modal.component';
import { SideLeftMenuComponent } from './layout/component-layout/side-left-menu/side-left-menu.component';
// import { JobCompleteCofirmationModalComponent } from './job-complete-cofirmation-modal/job-complete-cofirmation-modal.component';
// import { MarketplaceDetailComponent } from './marketplace/marketplace-detail/marketplace-detail.component';
import { MarketplaceProductComponent } from './marketplace/marketplace-product/marketplace-product.component';


import {
  HAMMER_GESTURE_CONFIG,
  HammerGestureConfig,
  HammerModule,
} from '@angular/platform-browser';
//import * as Hammer from 'hammerjs';

export class MyHammerConfig extends HammerGestureConfig {
  override overrides = {
    swipe: {
      //direction: Hammer.DIRECTION_HORIZONTAL,
      threshold: 50,
    },
  };
}
// import * as Hammer from 'hammerjs';
import { AdvancedSettingsComponent } from './advanced-settings/advanced-settings.component';
import { AdvancedSettingsReferralComponent } from './advanced-settings-referral/advanced-settings-referral.component';
import { FaqComponent } from './faq/faq.component';
import { FaqItemComponent } from './faq/faq-item/faq-item.component';
import {
  BaseChartDirective,
  provideCharts,
  withDefaultRegisterables,
} from 'ng2-charts';
// export class MyHammerConfig extends HammerGestureConfig {
//   override overrides = {
//     swipe: {
//       direction: Hammer.DIRECTION_HORIZONTAL,
//       threshold: 50,
//     },
//   };
// }

import { ImageModalComponent } from '../shareModule/component/chat/chatbot/image-modal.component';
import { AllNotificationsModalComponent } from './marketplace/notification/all-notifications-modal.component';
import { ReportChatMessageModalComponent } from '../shareModule/component/chat/chatbot/report-modal.component';
import { PatchNoteComponent } from './customer-footer/patch-note/patch-note.component';
import { NgxPopperjsModule } from 'ngx-popperjs';
import { BizOwnerPopupComponent } from './marketplace/view-product-details/biz-owner-popup/biz-owner-popup.component';
import { CommunityTrendingComponent } from './community/community-trending/community-trending.component';
import { BizCardComponent } from './biz-card/biz-card.component';
import { BizNameCardComponent } from './biz-name-card/biz-name-card.component';
import { RecommandationsFormComponent } from './community/recommandations-form/recommandations-form.component';
import { RecommendPageComponent } from './recommend-page/recommend-page.component';
import { BizLayoutComponent } from './biz-layout/biz-layout.component';
import { HowItWorksComponent } from './how-it-works/how-it-works.component';
import { VidplayerComponent } from './community/vidplayer/vidplayer.component';
import { LinkShareComponent } from './link-share/link-share.component';
import { SiteLinksComponent } from './community/site-links/site-links.component';
import { TagSelectorComponent } from './community/tag-selector/tag-selector.component';
import { ProductFaqListComponent } from './product-faq-list/product-faq-list.component';
import { ProductTypesListComponent } from './product-types-list/product-types-list.component';
import { CroppedImageComponent } from './cropped-image/cropped-image.component';
import { VerifyEmailPopupComponent } from '../shareModule/component/verify-email-popup/verify-email-popup.component';
import { BreadcrumbComponent } from '../shareModule/component/breadcrumb/breadcrumb.component';
import { SingleForumComponent } from './forum/tab-forum/single-forum/single-forum.component';
import { CompareProductListComponent } from './compare-product-list/compare-product-list.component';
import { FormForumComponent } from './forum/tab-forum/form-forum/form-forum.component';
import { SelectForumModalComponent } from '../select-forum-modal/select-forum-modal.component';
import { SelectProductToAttachComponent } from '../select-product-to-attach/select-product-to-attach.component';
import { ForumListComponent } from './forum-list/forum-list.component';
import { UploadEditedImageComponent } from '../community/upload-edited-image/upload-edited-image.component';
import { AdvancedSettingsIntroComponent } from './advanced-settings/advanced-settings-intro/advanced-settings-intro.component';
import { AdvancedSettingsContributionComponent } from './advanced-settings/advanced-settings-contribution/advanced-settings-contribution.component';
import { NewsForumComponent } from './forum/tab-forum/news-forum/news-forum.component';
import { NearbyAllServicesComponent } from './community/member-page/me/nearbyproducts-me/all-services/all-services.component';
import { ImageCropperComponent } from 'ngx-image-cropper';

class MyErrorHandler implements ErrorHandler {
  handleError(error: Error): void {
    console.log(error, "ERROR")
    // // Log error details
    // // Show file and line in error log
    // const stackLines = (error.stack || '').split('\n');
    // let fileLineInfo = '';
    // if (stackLines.length > 1) {
    //   // Try to extract file and line from the first stack line that looks like a file reference
    //   const match = stackLines[1].match(/(?:\()?(.*):(\d+):(\d+)\)?/);
    //   if (match) {
    //     fileLineInfo = `${match[1]}:${match[2]}`;
    //   }
    // }
    // console.error('[Angular Error Handler]:', {
    //   name: error.name,
    //   message: error.message,
    //   stack: error.stack,
    //   file: fileLineInfo,
    //   timestamp: new Date().toISOString()
    // });

    // // Handle specific error types
    // if (error instanceof TypeError) {
    //   console.error('[Type Error]:', error.message);
    // } else if (error instanceof ReferenceError) {
    //   console.error('[Reference Error]:', error.message);
    // } else if (error instanceof HttpErrorResponse) {
    //   console.error('[HTTP Error]:', {
    //     status: error.status,
    //     statusText: error.statusText,
    //     url: error.url
    //   });
    // }

    // Optionally rethrow to not swallow errors
    // throw error;
  }
}

@NgModule({
  declarations: [
    UploadEditedImageComponent,
    SelectProductToAttachComponent,
    SelectForumModalComponent,
    FormForumComponent,
    CompareProductListComponent,
    SingleForumComponent,
    BreadcrumbComponent,
    VerifyEmailPopupComponent,
    ProductFaqListComponent,
    ProductTypesListComponent,
    TagSelectorComponent,
    LinkShareComponent,
    VidplayerComponent,
    RecommandationsFormComponent,
    RecommendPageComponent,
    BizNameCardComponent,
    PrivacyPolicyComponent,
    ContactUsComponent,
    SignupComponent,
    CustomerHeaderComponent,
    CustomerDetailComponent,
    CustomerFeedbackCardComponent,
    BannerComponentComponent,
    RepairTabsComponent,
    GuestRepairComponent,
    CustomerSellPhoneComponent,
    CustomerShoppingComponent,
    SettingProfileComponent,
    CustomerBottomBannerComponent,
    LuckyDrawComponent,
    ForumComponent,
    ForumProfilePopupComponent,
    PollComponent,
    GiveawayComponent,
    GiveawaySurveyComponent,
    SingleNewComponent,
    FormNewComponent,
    NotificationComponent,
    AllNotificationsModalComponent,
    NotificationBookingComponent,
    MarketplaceProfileComponent,
    MarketplaceProfileCharacterComponent,
    // MemberShopProductComponent,
    MemberShopProductSearchComponent,
    GoogleMapComponent,
    ClickOutsideDirective,
    CommonFooterComponent,
    MarketplacePageComponent,
    // MarketplaceDetailComponent,
    MarketplaceShopDetailComponent,
    NewsComponent,
    BizCardComponent,
    BulletinComponent,
    // CommunityComponent,
    CustomersLayoutComponent,
    CustomersLayoutReferralComponent,
    ChatComponent,
    ChatBotComponent,
    ImageModalComponent,
    ReportChatMessageModalComponent,
    ChatLearnComponent,
    ChatMemoryComponent,
    RolesComponent,
    TabForumComponent,
    NewsForumComponent,
    MemberPageComponent,
    CommunitySearchComponent,
    CommunityTrendingComponent,
    CommunityProfileComponent,
    HeaderSearchMapComponent,
    FilterProductsComponent,
    SiteLinksComponent,
    SearchComponent,
    ProfileMeComponent,
    AskMeComponent,
    NewsMeComponent,
    AddMeComponent,
    NearbyproductsMeComponent,
    MemberProfileCharacterComponent,
    EventsComponent,
    OnlineToggleButtonComponent,
    IndividualRentalComponent,
    IndividualAllProductComponent,
    IndividualFreeComponent,
    IndividualServicesComponent,
    IndividualEventsComponent,
    OtherCommuntyPageComponent,
    BuyComponent,
    SellComponent,
    ReferComponent,
    WriteArticlesComponent,
    LevelProfileComponent,
    AvatarProfileComponent,
    StoreProfileComponent,
    MyTabsComponent,
    MemberShopComponent,
    LoudspeakerShopComponent,
    TimerComponent,
    ShopPageComponent,
    // ChatPageComponent,
    HowToEarnComponent,
    SignInComponent,
    TermsOfServiceComponent,
    TermsOfRentalComponent,
    MemberRegionSelectModalComponent,
    MemberProfileRolesComponent,
    CarouselMiniCardComponent,
    DiamondsPopupComponent,
    OtpInputComponent,
    PDPAPolicyComponent,
    ViewProductDetailsComponent,
    // CustomerServiceComponent,
    SurveyComponent,
    AroundeMeComponent,
    DropdownStatusComponent,
    JobCompleteCofirmationModalComponent,
    SideLeftMenuComponent,
    AdvancedSettingsComponent,
    AdvancedSettingsReferralComponent,
    AdvancedSettingsIntroComponent,
    AdvancedSettingsContributionComponent,
    FaqComponent,
    FaqItemComponent,
    PatchNoteComponent,
    BizOwnerPopupComponent,
    MarketplaceProductComponent,
    BizLayoutComponent,
    HowItWorksComponent,
    ForumListComponent,
    NearbyAllServicesComponent,
  ],
  imports: [
    NgxIntlTelInputModule,
    FormsModule,
    ReactiveFormsModule,
    NgOtpInputModule,
    NzTabsModule,
    CustomersRoutingModule,
    CarouselModule,
    CKEditorModule,
    ShareModule,
    CommonModule,
    // HammerModule,
    BaseChartDirective,
    NgxPopperjsModule.forRoot(),
    ImageCropperComponent,

  ],
  exports: [CommonModule, CustomerHeaderComponent, SignupComponent, ViewProductDetailsComponent],
  providers: [
    provideHttpClient(withJsonpSupport()),
    provideCharts(withDefaultRegisterables()),
    { provide: ErrorHandler, useClass: MyErrorHandler }
    // {
    //   provide: HAMMER_GESTURE_CONFIG,
    //   useClass: MyHammerConfig,
    // },
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class CustomersModule {
  constructor() { }
}
